import { HttpErrorResponse } from '@angular/common/http';
import { throwError, timer } from 'rxjs';

export const retryStrategy =
  ({
    maxRetryAttempts = 3,
    scalingDuration = 1000,
    excludedStatusCodes = [401, 403],
  }: {
    maxRetryAttempts?: number;
    scalingDuration?: number;
    excludedStatusCodes?: number[];
  } = {}) =>
  (error: unknown, retryCount: number) => {
    const retryAttempt = retryCount + 1;
    // if maximum number of retries have been met
    // or response is a status code we don't wish to retry, throw error
    if (retryAttempt > maxRetryAttempts || excludedStatusCodes.find((e) => e === (error as HttpErrorResponse).status)) {
      return throwError(() => error);
    }
    // retry after 1s, 2s, etc...
    return timer(retryAttempt * scalingDuration);
  };
